import { render, staticRenderFns } from "./AppCommodity.vue?vue&type=template&id=78d114dd&scoped=true&"
import script from "./AppCommodity.vue?vue&type=script&lang=js&"
export * from "./AppCommodity.vue?vue&type=script&lang=js&"
import style0 from "./AppCommodity.vue?vue&type=style&index=0&id=78d114dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d114dd",
  null
  
)

component.options.__file = "AppCommodity.vue"
export default component.exports